/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Share_Audio_DescInputs */

const en_dialog_share_audio_desc = /** @type {(inputs: Dialog_Share_Audio_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`They can read & listen to the audio for free`)
};

const es_dialog_share_audio_desc = /** @type {(inputs: Dialog_Share_Audio_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pueden leer y escuchar el audio gratis`)
};

/**
* | output |
* | --- |
* | "They can read & listen to the audio for free" |
*
* @param {Dialog_Share_Audio_DescInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_share_audio_desc = /** @type {((inputs?: Dialog_Share_Audio_DescInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Share_Audio_DescInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_share_audio_desc(inputs)
	return en_dialog_share_audio_desc(inputs)
});